var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDownload1BackgroundLarge(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1206,
    height: 1104,
    viewBox: "0 0 1206 1104",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_81_2885",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 1206,
    height: 1104
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 1203,
    height: 1101,
    rx: 51.5,
    fill: "#EBF5FF",
    fillOpacity: 0.3,
    stroke: "url(#paint0_linear_81_2885)",
    strokeWidth: 3
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_81_2885)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_81_2885)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M976.744 835.189C1067.89 835.189 1150.29 786.051 1209.85 706.83C1269.41 627.609 1306.21 518.235 1306.21 397.487C1306.21 276.739 1269.41 167.365 1209.85 88.1441C1150.29 8.92274 1067.89 -40.2151 976.744 -40.2151C885.603 -40.2151 803.203 8.92274 743.639 88.1441C684.076 167.365 647.279 276.739 647.279 397.487C647.279 518.235 684.076 627.609 743.639 706.83C803.203 786.051 885.603 835.189 976.744 835.189Z",
    fill: "#C1BCFF",
    stroke: "url(#paint1_linear_81_2885)",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.965 936.217C321.106 936.217 403.506 887.079 463.07 807.857C522.633 728.637 559.43 619.262 559.43 498.515C559.43 377.767 522.633 268.392 463.07 189.172C403.506 109.95 321.106 60.8125 229.965 60.8125C138.824 60.8125 56.4235 109.95 -3.14023 189.172C-62.7035 268.392 -99.5 377.767 -99.5 498.515C-99.5 619.262 -62.7035 728.637 -3.14023 807.857C56.4235 887.079 138.824 936.217 229.965 936.217Z",
    fill: "#C1BCFF",
    stroke: "url(#paint2_linear_81_2885)",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.083 858.96C260.154 858.96 324.384 820.665 370.796 758.973C417.207 697.282 445.868 612.125 445.868 518.126C445.868 424.127 417.207 338.97 370.796 277.278C324.384 215.587 260.154 177.292 189.083 177.292C118.011 177.292 53.7812 215.587 7.36967 277.278C-39.0414 338.97 -67.7031 424.127 -67.7031 518.126C-67.7031 612.125 -39.0414 697.282 7.36967 758.973C53.7812 820.665 118.011 858.96 189.083 858.96Z",
    fill: "#FFD9DD",
    stroke: "url(#paint3_linear_81_2885)",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M536.126 851.829C607.197 851.829 671.427 813.534 717.839 751.842C764.25 690.151 792.911 604.993 792.911 510.994C792.911 416.996 764.25 331.838 717.839 270.147C671.427 208.455 607.197 170.16 536.126 170.16C465.054 170.16 400.824 208.455 354.413 270.147C308.002 331.838 279.34 416.996 279.34 510.994C279.34 604.993 308.002 690.151 354.413 751.842C400.824 813.534 465.054 851.829 536.126 851.829Z",
    fill: "#DEB5FF",
    stroke: "url(#paint4_linear_81_2885)",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.363 1144.22C380.162 1144.22 438.714 1109.31 481.015 1053.11C523.316 996.899 549.436 919.319 549.436 833.689C549.436 748.06 523.316 670.479 481.015 614.273C438.714 558.066 380.162 523.163 315.363 523.163C250.563 523.163 192.011 558.066 149.71 614.273C107.409 670.479 81.2891 748.06 81.2891 833.689C81.2891 919.319 107.409 996.899 149.71 1053.11C192.011 1109.31 250.563 1144.22 315.363 1144.22Z",
    fill: "#C173FF",
    stroke: "url(#paint5_linear_81_2885)",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M470.714 1017.04C535.513 1017.04 594.065 982.136 636.367 925.929C678.668 869.723 704.788 792.142 704.788 706.513C704.788 620.883 678.668 543.303 636.367 487.096C594.065 430.889 535.513 395.987 470.714 395.987C405.915 395.987 347.363 430.889 305.061 487.096C262.76 543.303 236.641 620.883 236.641 706.513C236.641 792.142 262.76 869.723 305.061 925.929C347.363 982.136 405.915 1017.04 470.714 1017.04Z",
    fill: "#C173FF",
    stroke: "url(#paint6_linear_81_2885)",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M946.309 923.143C1025.03 923.143 1096.19 880.723 1147.62 812.364C1199.04 744.005 1230.8 649.636 1230.8 545.463C1230.8 441.29 1199.04 346.921 1147.62 278.562C1096.19 210.202 1025.03 167.783 946.309 167.783C867.586 167.783 796.429 210.202 745.003 278.562C693.578 346.921 661.814 441.29 661.814 545.463C661.814 649.636 693.578 744.005 745.003 812.364C796.429 880.723 867.586 923.143 946.309 923.143Z",
    fill: "#AAEBFF",
    stroke: "url(#paint7_linear_81_2885)",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.245 622.437C264.573 622.437 303.235 588.129 303.235 545.463C303.235 502.797 264.573 468.489 217.245 468.489C169.918 468.489 131.256 502.797 131.256 545.463C131.256 588.129 169.918 622.437 217.245 622.437Z",
    fill: "#FFDA58",
    stroke: "url(#paint8_linear_81_2885)",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.245 593.911C264.573 593.911 303.235 559.603 303.235 516.937C303.235 474.271 264.573 439.964 217.245 439.964C169.918 439.964 131.256 474.271 131.256 516.937C131.256 559.603 169.918 593.911 217.245 593.911Z",
    fill: "#FFDD65",
    stroke: "url(#paint9_linear_81_2885)",
    strokeWidth: 3
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_81_2885",
    x: -384.591,
    y: -325.306,
    width: 1975.89,
    height: 1754.61,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 141.795,
    result: "effect1_foregroundBlur_81_2885"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_81_2885",
    x1: 1203,
    y1: 3,
    x2: -209.583,
    y2: 585.325,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3939"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#50C0FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_81_2885",
    x1: 976.744,
    y1: -38.7151,
    x2: 976.744,
    y2: 833.689,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3939"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5956FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_81_2885",
    x1: 229.965,
    y1: 62.3125,
    x2: 229.965,
    y2: 934.717,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3939"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5956FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_81_2885",
    x1: 189.083,
    y1: 178.792,
    x2: 189.083,
    y2: 857.46,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3939"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5956FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_81_2885",
    x1: 536.126,
    y1: 171.66,
    x2: 536.126,
    y2: 850.329,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3939"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5956FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_81_2885",
    x1: 315.363,
    y1: 524.663,
    x2: 315.363,
    y2: 1142.72,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3939"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5956FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_81_2885",
    x1: 470.714,
    y1: 397.487,
    x2: 470.714,
    y2: 1015.54,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3939"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5956FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_81_2885",
    x1: 946.309,
    y1: 169.283,
    x2: 946.309,
    y2: 921.643,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3939"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5956FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_81_2885",
    x1: 217.245,
    y1: 469.989,
    x2: 217.245,
    y2: 620.937,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3939"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5956FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_81_2885",
    x1: 217.245,
    y1: 441.464,
    x2: 217.245,
    y2: 592.411,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3939"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5956FF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload1BackgroundLarge);
export default __webpack_public_path__ + "static/media/download-1-background-large.4dc19b81db6c65571cecbb1f47c06a51.svg";
export { ForwardRef as ReactComponent };